






















import * as _ from 'lodash';
import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import $ from 'jquery';
import { MobileState } from '../../../types/Enum/index';

@Component({
  components: {
  },
})
export default class StateBar extends Vue {
    private today: Date = new Date();

    private hours: string = '';

    private date: string = '';

    // private state: MobileState = MobileState.LOCKED;

    private state: MobileState = MobileState.LOCKED;

    public getHours() : string {
      const pad:Function = (nbr: number) => ((nbr < 10) ? `0${nbr}` : `${nbr}`);
      return `${this.today.getHours()}:${pad(this.today.getDate())}`;
    }

    public mounted() {
      this.today = new Date();
      setInterval(() => {
        this.hours = this.getHours();
      }, 1000);
    }
}
